<script lang="ts" setup>

var props = defineProps({
  numSteps: {
    type: Number,
    required: true,
  },
  currentStep: {
    type: Number,
    required: true,
  },
  totalScore: {
    type: Number,
    required: true,
  },
  totalEarnedScore: {
    type: Number,
    required: true,
  },
});

defineEmits(["next", "previous"]);

const current = computed(() => {
  return props.currentStep;
});

const total = computed(() => {
  return props.numSteps;
});

const progress = computed(() => {
  return current.value / total.value;
});
</script>

<template>
  <div class="border-t-[1px] flex flex-col">
    <!-- <div
      class="mt-4 p-2 flex flex-row justify-between bg-light-default border rounded"
    >
      <span class="font-bold">Total Score</span>
      <span class="font-bold"> {{ totalEarnedScore }} / {{ totalScore }} </span>
    </div> -->
    <div class="flex flex-row items-center py-4 px-4">
      <div class="pr-2 flex flex-row text-sm">
        <div class="text-right w-[20px] pr-2">{{ current }}</div>
        <div>/ {{ total }}</div>
      </div>

      <BaseProgressBar class="grow" :progress="progress"></BaseProgressBar>
    </div>
    <!-- <div class="flex flex-row justify-between">
      <BaseTextButton @click="$emit('previous')">
        <FontAwesomeIcon icon="fa-solid fa-arrow-left"></FontAwesomeIcon>
        <span class="ml-2"> Previous Step </span>
      </BaseTextButton>
      <BaseOutlinedButton @click="$emit('next')">
        <span class="mr-2">Next Step</span>
        <FontAwesomeIcon icon="fa-solid fa-arrow-right"></FontAwesomeIcon>
      </BaseOutlinedButton>
    </div> -->
  </div>
</template>

<style scoped></style>
